<template>
	<div class="stream-rte-toolbar">
		<RteToolbar
			:disable-all="disableAllActions"
			:hasSelection="hasSelection"
			:activeNodeType="activeNodeType"
			:allowedTeamingActions="allowedTeamingActions"
			@editAction="onEditAction"
		/>
	</div>
</template>

<script>
import {
	TeamingTiptapExtensionType,
	TiptapNativeNodeType
} from "@teaming/common-enums";

import RteToolbar from "./RteToolbar.vue";

export default {
	name: "StreamToolbar",
	teamingPackage: "common-team",
	emits: [
		"editAction",
	],
	components: {
		RteToolbar,
	},
	props: {
		documentName: {
			type: String,
			required: true,
		},
		allowedTeamingActions: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			initialized: false,
			activeSubDocId: "",
		};
	},
	computed: {
		disableAllActions() {
			return !this.activeSubDocId;
		},
		hasSelection() {
			const { activeSubDocId, } = this;

			if ( !activeSubDocId ) {
				return false;
			}

			const manager = this.$documentRegistry()
				.manage( this.documentName );
			const editor = manager.getEditor( activeSubDocId );

			const { view, state, } = editor;
			const { from, to, } = view.state.selection;
			const text = state.doc.textBetween( from, to, "" );
			return !!text;
		},
		activeNodeType() {
			const { activeSubDocId, } = this;

			if ( !activeSubDocId ) {
				return;
			}

			const manager = this.$documentRegistry()
				.manage( this.documentName );
			const editor = manager.getEditor( activeSubDocId );

			if ( editor.isActive( "teaming-commitment" ) ) {
				return TeamingTiptapExtensionType.COMMITMENT;
			}

			if ( editor.isActive( "teaming-decision" ) ) {
				return TeamingTiptapExtensionType.DECISION;
			}

			if ( editor.isActive( "teaming-topic" ) ) {
				return TeamingTiptapExtensionType.TOPIC;
			}

			// NOTE: In TipTap, headings 1-6 are represented by a single node type,
			// "heading". If we ever move beyond a single heading type we will need
			// to account for that here.
			if ( editor.isActive( "heading" ) ) {
				return TiptapNativeNodeType.HEADING;
			}

			return null;
		},
	},
	methods: {
		onEditAction( action ) {
			const { activeSubDocId: subDocId, } = this;
			this.$emit( "editAction", { action, subDocId, } );
		},
		editorActivated( subDocId ) {
			this.activeSubDocId = subDocId;
		},
		editorDeactivated() {
			this.activeSubDocId = "";
		},
		createListeners() {
			const { initialized, documentName, } = this;
			if ( initialized || !documentName ) {
				return;
			}
			const registry = this.$documentRegistry();
			registry.on( `${ documentName }.editorActivated`, this.editorActivated );
			registry.on( `${ documentName }.editorDeactivated`, this.editorDeactivated );
			this.initialized = true;
		},
		disposeListeners() {
			const { documentName, } = this;
			const registry = this.$documentRegistry();
			registry.off( `${ documentName }.editorActivated`, this.editorActivated );
			registry.off( `${ documentName }.editorDeactivated`, this.editorDeactivated );
		},
	},
	mounted() {
		this.createListeners();
	},
	updated() {
		this.createListeners();
	},
	beforeUnmount() {
		this.disposeListeners();
	},
};
</script>
